<template>
  <div class="app flex-row align-items-center">
    <div class="container centered-content">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Iniciar sesión en su cuenta</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="username"
                      type="text"
                      class="form-control"
                      placeholder="Usuario"
                      autocomplete="username email"
                      trim
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="password"
                      type="password"
                      class="form-control"
                      placeholder="Contraseña"
                      autocomplete="current-password"
                      @keyup.native="handleEnter"
                      trim
                    />
                  </b-input-group>
                  <b-row>
                    <b-col>
                      <b-button
                        v-if="!loggingIn"
                        :disabled="
                          username.length === 0 ||
                          password.length === 0 ||
                          isLoading
                        "
                        variant="success"
                        class="px-4"
                        @click="performLogin()"
                        >Entrar</b-button
                      >
                      <b-spinner
                        v-if="loggingIn"
                        variant="success"
                        label="Spinning"
                      ></b-spinner>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col>
                      <b-form-checkbox
                        id="checkbox-1"
                        v-model="rememberUserCheck"
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false"
                        >Recordar mi usuario</b-form-checkbox
                      >
                    </b-col>
                    <!-- <b-col class="text-right">
                      <b-button variant="link" class="px-0"
                        >¿Ha olvidado la contraseña?</b-button
                      >
                    </b-col> -->
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button variant="link" class="px-0" @click="returnWeb"
                        >Volver a martin agentes inmobiliarios</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-light py-5 d-md-down-none login-logo-container"
              style="width: 44%"
            >
              <b-card-body class="text-center">
                <div>
                  <img
                    class="login-logo"
                    src="/img/brand/logo_login.png"
                    alt="logo"
                    width="300px"
                  />
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SecurityRepository = RepositoryFactory.get("security");

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      rememberUserCheck: false,
      loggingIn: false,
    };
  },
  computed: {
    isLoading() {
      return SecurityRepository.isLoading();
    },
    hasError() {
      return SecurityRepository.hasError();
    },
    error() {
      return SecurityRepository.error();
    },
  },
  created() {
    this.checkAuthentication();
  },
  methods: {
    async performLogin() {
      this.loggingIn = true;
      let payload = {
          username: this.$data.username,
          password: this.$data.password,
        },
        redirect = this.$route.query.redirect;
      if (this.rememberUserCheck) {
        localStorage.setItem("remmemberedUsername", payload.username);
      }
      await SecurityRepository.login(payload);
      if (!SecurityRepository.hasError()) {
        if (typeof redirect !== "undefined") {
          this.$router.push({ path: redirect });
        } else {
          this.$router.push({ path: "/catalogo" });
        }
      } else {
        this.$toast.error("Usuario / Contraseña incorrectas", {
          position: "top",
          duration: 5000,
        });
        this.$data.password = "";
      }
      this.loggingIn = false;
    },
    checkAuthentication() {
      let redirect = this.$route.query.redirect;
      if (SecurityRepository.isAuthenticated()) {
        if (typeof redirect !== "undefined") {
          this.$router.push({ path: redirect });
        } else {
          this.$router.push({ path: "/" });
        }
      } else if (localStorage.getItem("remmemberedUsername")) {
        this.rememberUserCheck = true;
        this.username = localStorage.getItem("remmemberedUsername");
      }
    },
    handleEnter(event) {
      if (
        event.which === 13 &&
        this.username.length > 0 &&
        this.password.length > 0 &&
        !this.isLoading
      ) {
        this.performLogin();
      }
    },
    returnWeb() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="css">
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #6e9360;
  background-color: #6e9360;
}
.centered-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media (max-width: 575px) {
  .login-logo-container {
    display: none;
  }
}
</style>
